import { render } from "./GradientBg3D.vue?vue&type=template&id=64b138d0&scoped=true&ts=true"
import script from "./GradientBg3D.vue?vue&type=script&lang=ts"
export * from "./GradientBg3D.vue?vue&type=script&lang=ts"

import "./GradientBg3D.vue?vue&type=style&index=0&id=64b138d0&scoped=true&lang=sass"

import exportComponent from "/Users/sotenck/GIT/kunden/iconomy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64b138d0"]])

export default __exports__